/* MKPBR 01/10/2026 - POPUP DO ADD TO CART + blocos "Pague menos frete" e "Complete seu pedido" do carrinho lateral.
   Depende de window.MKCD (assets/mkpbr-cdrw.js). Documentacao em snippets/mkpbr-cdrw.liquid.
   17/10/2026 (conversao):
   - com "atcPopup":false no #mkcd-cfg o Add to cart inclui direto e abre a gaveta, sem o popup do par (hoje
     desligado: so 4 dos 60 mais vendidos tinham par e ele interrompia o Add to cart);
   - "Pague menos frete" com 1 item no carrinho tambem oferece +1 unidade DO MESMO produto quando ela faz o
     frete cair um degrau (ex.: Franca, item de US$ 35: a 2a unidade custa so +EUR 5,79 no total, porque o
     frete cai e entra a faixa de 5%). Essa linha vem sempre primeiro. */
(function(){
  'use strict';
  var D = document, W = window;
  function boot(){
    var M = W.MKCD; if (!M || M.__offer) return; M.__offer = 1;
    var tr = M.t, esc = M.esc, MF = M.MF, ROOT = M.root, CFG = M.cfg;
    function $(s, r){ return (r || D).querySelector(s); }

    /* ---------- dados por Section Rendering API (no idioma e moeda do mercado), com cache ---------- */
    var cache = {};
    function load(key, url){
      if (!cache[key]) cache[key] = fetch(url, { credentials: 'same-origin' }).then(function(r){ return r.ok ? r.text() : ''; }).then(function(h){
        var m = h.match(/<script type="application\/json" data-mkcd-data>([\s\S]*?)<\/script>/); if (!m) return null;
        try { return JSON.parse(m[1]); } catch (e) { return null; }
      }).catch(function(){ return null; });
      return cache[key];
    }
    var SEC = 'section_id=mkpbr-cdrw-data';
    function pdpData(h){ return load('p:' + h, ROOT + 'products/' + encodeURIComponent(h) + '?' + SEC); }
    function addons(){ return CFG.addons ? load('col', ROOT + 'collections/' + CFG.addons + '?' + SEC) : Promise.resolve(null); }
    function recs(pid){ return load('r:' + pid, ROOT + 'recommendations/products?' + SEC + '&product_id=' + pid + '&limit=10&intent=related'); }

    function inCartIds(c){ var o = {}; (c && c.items || []).forEach(function(it){ o[it.product_id] = 1; }); return o; }
    function firstAvail(p){ for (var i = 0; i < p.vs.length; i++) if (p.vs[i].a) return p.vs[i]; return null; }
    function cheapestAvail(p){ var b = null; p.vs.forEach(function(v){ if (v.a && (!b || v.p < b.p)) b = v; }); return b; }
    /* regra das lojas oficiais (28/09): carrinho so com uma marca oficial -> sugestoes so dessa marca */
    function onlyVendor(c){
      var vs = {}; (c.items || []).forEach(function(it){ vs[String(it.vendor || '').toLowerCase().trim()] = 1; });
      var k = Object.keys(vs); return (k.length === 1 && M.off.indexOf(k[0]) > -1) ? k[0] : null;
    }
    function okVendor(p, only){ return !only || String(p.v || '').toLowerCase().trim() === only; }

    /* tamanho em ml/g a partir do titulo (para casar a variante do par com a escolhida: 300 g -> 250 ml, 1 kg -> 1 L) */
    function size(txt){
      var s = String(txt || '').toLowerCase().replace(/(\d),(\d)/g, '$1.$2'), m = s.match(/(\d+(?:\.\d+)?)\s*(ml|litros?|liters?|litres?|lt|l|kg|gr|g)\b/);
      if (m) { var q = parseFloat(m[1]), u = m[2]; return (u === 'kg' || u === 'l' || u === 'lt' || u.indexOf('lit') === 0) ? q * 1000 : q; }
      m = s.match(/(\d+(?:\.\d+)?)\s*(fl\.?\s?oz|oz)\b/); if (m) return parseFloat(m[1]) * (m[2].indexOf('fl') === 0 ? 29.57 : 28.35);
      return null;
    }
    function matchVariant(p, ref){
      var av = p.vs.filter(function(v){ return v.a; }); if (!av.length) return null; if (av.length === 1 || !ref) return av[0];
      var best = null; av.forEach(function(v){ var s = size(v.t); if (!s) return; var d = Math.abs(Math.log(s / ref)); if (!best || d < best.d) best = { v: v, d: d }; });
      return best ? best.v : av[0];
    }

    /* =================== 1) POPUP DO ADD TO CART =================== */
    var busy = false;
    function isTarget(f){
      if (!f || !f.getAttribute) return false;
      if (!/\/cart\/add/.test(f.getAttribute('action') || '')) return false;
      return !(f.closest && f.closest('.mkcd, .mkcp, [data-mkcd-skip]'));
    }
    function handleOf(f){
      var u = f.getAttribute('data-url') || '';
      var inModal = f.closest('.modal, [data-modal-container], [data-quickshop]');
      if (!u && !inModal && CFG.ph && f.closest('.product--outer, [data-product-form-area], [data-product-form-regular]')) return CFG.ph;
      if (!u) { var q = f.closest('[data-product-quickshop-url]'); if (q) u = q.getAttribute('data-product-quickshop-url'); }
      if (!u) { var box = inModal || f.closest('[data-product-item], .productitem, article, li'); var a = box && box.querySelector('a[href*="/products/"]'); if (a) u = a.getAttribute('href'); }
      var m = String(u).match(/\/products\/([^/?#]+)/);
      if (m) return decodeURIComponent(m[1]);
      return (!inModal && CFG.ph) ? CFG.ph : '';
    }
    function seenKey(pid){ return 'mkcp_' + pid; }
    function wasShown(pid){ try { return !!sessionStorage.getItem(seenKey(pid)); } catch (e) { return false; } }
    function markShown(pid){ try { sessionStorage.setItem(seenKey(pid), '1'); } catch (e) {} }
    function setBusy(b, on){ if (!b) return; b.disabled = on; b.classList.toggle('is-loading', on); b.setAttribute('aria-busy', on ? 'true' : 'false'); }
    function showErr(f, msg){
      var p = f.querySelector('.mkcp__err'); if (!p) { p = D.createElement('p'); p.className = 'mkcp__err'; f.appendChild(p); }
      p.textContent = msg || tr('err'); setTimeout(function(){ if (p.parentNode) p.parentNode.removeChild(p); }, 6000);
    }
    function closeModalOf(f){ var m = f.closest('.modal, [data-modal-container]'); if (m) { var x = m.querySelector('[data-modal-close]'); if (x) x.click(); } }
    /* PDP de 3 colunas: o seletor de tamanho fica FORA do formulario e um script do tema copia o valor para dentro
       no clique. Este ouvinte roda antes dele, entao a variante e lida direto do seletor. */
    function pdpVariant(f){
      try {
        var o = f.closest('.product--outer'); if (!o) return null;
        var ui = o.querySelector('[data-variants-ui]'); if (!ui) return null;
        if (o.querySelector('form[action*="/cart/add"]') !== f) return null;   /* so o formulario principal da PDP */
        var s = ui.matches('[name="id"]') ? ui : ui.querySelector('select[name="id"], input[name="id"]');
        return (s && s.closest('form') !== f && s.value) ? s.value : null;
      } catch (e) { return null; }
    }
    function within(p, ms, v){ return Promise.race([p, new Promise(function(r){ setTimeout(function(){ r(v); }, ms); })]); }

    function intercept(e, f, btn, isClick){
      var fd; try { fd = new FormData(f); } catch (x) { return; }
      var id = pdpVariant(f) || fd.get('id'); if (!id) return;   /* sem variante: deixa o tema tratar */
      /* clique: so impede o envio do formulario (o Empire e a home incluem no "submit"); os outros ouvintes
         do clique continuam rodando (ex.: bloco de desconto por quantidade). Submit: corta tudo. */
      e.preventDefault(); if (!isClick) e.stopImmediatePropagation();
      if (busy) return; busy = true;
      var qty = Math.max(1, parseInt(fd.get('quantity') || '1', 10) || 1), props = {}, hasP = false;
      fd.forEach(function(v, k){ var mm = k.match(/^properties\[(.+)\]$/); if (mm && v !== '') { props[mm[1]] = v; hasP = true; } });
      var main = { id: Number(id), quantity: qty }; if (hasP) main.properties = props;
      var sp = fd.get('selling_plan'); if (sp) main.selling_plan = sp;
      btn = btn || f.querySelector('[type="submit"], button:not([type])'); setBusy(btn, true);
      var h = handleOf(f);
      var done = function(){ busy = false; setBusy(btn, false); };
      var addOnly = function(){
        return M.add([main]).then(function(){ closeModalOf(f); }).catch(function(err){ showErr(f, err && err.body && (err.body.description || err.body.message)); });
      };
      /* popup desligado (17/10): inclui direto pela gaveta, sem esperar dados do par (mais rapido e sem o aviso do Empire) */
      if (CFG.atcPopup === false) { addOnly().then(done, done); return; }
      within(Promise.all([h ? pdpData(h) : Promise.resolve(null), M.refresh().catch(function(){ return null; })]), 3500, null).then(function(r){
        if (!r) return addOnly();
        var d = r[0], c = r[1] || M.cart();
        var off = d && d.k === 'pdp' ? pickOffer(d, main, c) : null;
        if (!off || wasShown(d.main.id)) return addOnly();
        markShown(d.main.id);
        return popup(d, main, off, c, f);
      }).catch(addOnly).then(done, done);
    }
    function pickOffer(d, main, c){
      var ic = inCartIds(c), mv = null;
      d.main.vs.forEach(function(v){ if (v.i === main.id) mv = v; });
      if (!mv) return null;                                   /* a variante nao e deste produto: nao arrisca */
      var ref = size(mv && mv.t !== 'Default Title' ? mv.t : d.main.t);
      for (var i = 0; i < (d.cs || []).length; i++) {
        var p = d.cs[i]; if (!p.av || ic[p.id] || p.id === d.main.id) continue;
        var v = matchVariant(p, ref); if (v) return { p: p, v: v, mv: mv || firstAvail(d.main) };
      }
      return null;
    }
    function card(p, v, lbl, cls, priceHTML){
      var vt = v && v.t !== 'Default Title' ? ' · ' + v.t : '';
      return '<div class="mkcp__card' + (cls || '') + '"><span class="mkcd__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="64" height="64">' : '') + '</span>' +
        '<div><div class="mkcp__lbl">' + esc(lbl) + '</div><div class="mkcd__ttl">' + esc(p.t + vt) + '</div><div class="mkcp__pr">' + priceHTML + '</div></div></div>';
    }
    function popup(d, main, off, c, f){
      return new Promise(function(resolve){
        var units = c ? c.item_count : 0, tOne = M.tierFor(units + main.quantity), tBoth = M.tierFor(units + main.quantity + 1);
        var pm = (off.mv ? off.mv.p : 0) * main.quantity, po = off.v.p, deal = '';
        if (tBoth > tOne) deal = tr('ptier', { p: tBoth }); else if (tBoth > 0) deal = tr('pkeep', { p: tBoth });
        var both = '';
        if (tBoth > 0 && !d.main.wp && !off.p.wp) both = '<b><s style="font-weight:500;color:#8a93a0;font-size:12.5px">' + MF(pm + po) + '</s> ' + esc(tr('ptotal', { x: MF(Math.round((pm + po) * (100 - tBoth) / 100)) })) + '</b>';
        var box = D.createElement('div'); box.className = 'mkcp'; if (M.rtl) box.setAttribute('dir', 'rtl');
        box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-labelledby', 'mkcp-h');
        box.innerHTML = '<button class="mkcp__veil" type="button" tabindex="-1" aria-label="' + esc(tr('close')) + '" data-no></button><div class="mkcp__box">' +
          '<button class="mkcp__x" type="button" aria-label="' + esc(tr('close')) + '" data-no>&times;</button>' +
          '<p class="mkcp__eye" id="mkcp-h">' + esc(tr('ph')) + '</p><p class="mkcp__sub">' + esc(tr('psub')) + '</p>' +
          card(d.main, off.mv, tr('pyou'), '', (main.quantity > 1 ? main.quantity + ' × ' : '') + MF(off.mv ? off.mv.p : 0)) +
          '<div class="mkcp__plus" aria-hidden="true">+</div>' +
          card(off.p, off.v, tr('ph'), ' is-offer', MF(po)) +
          (deal ? '<div class="mkcp__deal">' + esc(deal) + both + '</div>' : '') +
          '<button class="mkcp__yes" type="button" data-yes>' + esc(tr('pboth')) + '</button>' +
          '<button class="mkcp__no" type="button" data-no>' + esc(tr('pno')) + '</button></div>';
        D.body.appendChild(box);
        var yes = $('[data-yes]', box), last = D.activeElement;
        setTimeout(function(){ try { yes.focus({ preventScroll: true }); } catch (e) {} }, 30);
        M.pub('mkpbr_atc_offer', { action: 'show', main: d.main.id, offer: off.p.id });
        var fin = function(){ D.removeEventListener('keydown', onKey); if (box.parentNode) box.parentNode.removeChild(box); try { if (last && last.focus) last.focus({ preventScroll: true }); } catch (e) {} resolve(); };
        var gone = false;
        var go = function(withOffer){
          if (gone) return; gone = true; D.removeEventListener('keydown', onKey);   /* um clique/Esc so: nunca inclui duas vezes */
          [].forEach.call(box.querySelectorAll('button'), function(b){ b.disabled = true; });
          var items = withOffer ? [main, { id: off.v.i, quantity: 1 }] : [main];
          M.pub('mkpbr_atc_offer', { action: withOffer ? 'yes' : 'no', main: d.main.id, offer: off.p.id });
          M.add(items).catch(function(err){
            if (withOffer && err && err.status === 422) return M.add([main]);   /* o par esgotou no meio do caminho: inclui so o principal */
            throw err;
          }).then(function(){ closeModalOf(f); fin(); }, function(err){ fin(); showErr(f, err && err.body && (err.body.description || err.body.message)); });
        };
        var onKey = function(e){ if (e.key === 'Escape') go(false); };
        D.addEventListener('keydown', onKey);
        box.addEventListener('click', function(e){
          if (e.target.closest('[data-yes]')) go(true); else if (e.target.closest('[data-no]')) go(false);
        });
      });
    }
    W.addEventListener('submit', function(e){ var f = e.target; if (isTarget(f)) intercept(e, f, e.submitter); }, true);
    W.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('button, input[type="submit"]'); if (!b) return;
      /* so botao de envio declarado (type=submit) ou o botao de compra conhecido; botao sem type de outro bloco nao conta */
      var tp = (b.getAttribute('type') || '').toLowerCase();
      if (tp ? tp !== 'submit' : !b.matches('[data-product-atc], .product-form--atc-button, .pc__add, .mini__add, [name="add"]')) return;
      var f = b.form || b.closest('form'); if (isTarget(f) && !b.disabled) intercept(e, f, b, true);
    }, true);

    /* =================== 2) PAGUE MENOS FRETE (itens que fazem o frete cair um degrau) =================== */
    var MINQ = M.tiers.length ? M.tiers[0][0] : 2;
    function isTierAlloc(a){ return /^buy \d/i.test((a.discount_application && a.discount_application.title) || ''); }
    /* simula o carrinho com +1 unidade: a faixa do Pumper vale para o carrinho inteiro; o Shopify fica com o
       maior desconto de produto em cada linha (faixa x Weekly Picks). Cupom de carrinho: mantem o valor. */
    function simulate(c, price){
      var units = c.item_count + 1, t = M.tierFor(units) / 100, tot = 0;
      c.items.forEach(function(it){
        var o = it.original_line_price, dl = 0, tier = true;
        (it.line_level_discount_allocations || []).forEach(function(a){ dl += a.amount; if (!isTierAlloc(a)) tier = false; });
        /* linha sem desconto nenhum com 2+ itens no carrinho = produto fora da faixa: continua sem desconto */
        var none = !(it.line_level_discount_allocations || []).length && c.item_count >= MINQ;
        var rate = none ? 0 : (tier ? t : Math.max(o > 0 ? dl / o : 0, t));
        tot += Math.round(o * (1 - rate));
      });
      tot += Math.round(price * (1 - t));
      (c.cart_level_discount_applications || []).forEach(function(a){ tot -= (a.total_allocated_amount || 0); });
      return { total: tot, units: units, tier: Math.round(t * 100) };
    }
    /* mesma conta, mas a unidade a mais entra na linha que ja esta no carrinho (fica com o desconto daquela linha) */
    function simSame(c, line){
      var units = c.item_count + 1, t = M.tierFor(units) / 100, tot = 0, unit = line.original_price;
      c.items.forEach(function(it){
        var o = it.original_line_price, dl = 0, tier = true;
        (it.line_level_discount_allocations || []).forEach(function(a){ dl += a.amount; if (!isTierAlloc(a)) tier = false; });
        var none = !(it.line_level_discount_allocations || []).length && c.item_count >= MINQ;
        var rate = none ? 0 : (tier ? t : Math.max(o > 0 ? dl / o : 0, t));
        if (it.key === line.key) { o += it.original_price; unit = Math.round(it.original_price * (1 - rate)); }
        tot += Math.round(o * (1 - rate));
      });
      (c.cart_level_discount_applications || []).forEach(function(a){ tot -= (a.total_allocated_amount || 0); });
      return { total: tot, units: units, tier: Math.round(t * 100), unit: unit };
    }
    /* +1 unidade do mesmo produto (so com 1 item no carrinho; com 2+ quem oferece a unidade extra e a oferta de 30%) */
    function sameItem(c, cur, curTier){
      if (c.item_count !== 1) return [];
      var out = [];
      c.items.forEach(function(it){
        if (it.gift_card || it.selling_plan_allocation || !(it.original_price > 0)) return;
        var sim = simSame(c, it), ns = M.shipState({ total_price: sim.total, item_count: sim.units, currency: c.currency });
        if (!ns || ns.calculado || ns.freteAtual == null || !ns.atual) return;
        var nf = Math.round(ns.freteAtual * 100); if (nf >= cur) return;
        if (sim.total / 100 < ns.atual.de * 1.01) return;   /* folga de 1%, como nos outros itens */
        var vt = (it.product_has_only_default_variant || !it.variant_title) ? 'Default Title' : it.variant_title;
        out.push({ same: true, p: { id: it.product_id, t: it.product_title, u: M.localUrl(it.url), img: it.image ? M.sizeImg(it.image, 120) : '', v: it.vendor },
                   v: { i: it.variant_id, p: it.original_price, t: vt }, unit: sim.unit, nf: nf,
                   delta: (sim.total + nf) - (c.total_price + cur), tier: sim.tier > curTier ? sim.tier : 0 });
      });
      return out;
    }
    var ladTok = 0;
    function ladder(c, root){
      var box = $('[data-mkcd-lad]', root), tok = ++ladTok;
      var s = M.shipState(c);
      if (!c.item_count || !s || s.calculado || s.freteAtual == null || s.freteAtual === 0 || !s.proximo) { box.hidden = true; box.__ids = ''; return Promise.resolve(); }
      var cur = Math.round(s.freteAtual * 100), curTier = M.tierFor(c.item_count), same = sameItem(c, cur, curTier);
      return addons().then(function(d){
        if (tok !== ladTok) return;
        if ((!d || d.k !== 'col' || !d.ps) && !same.length) { box.hidden = true; box.__ids = ''; return; }
        var ic = inCartIds(c), only = onlyVendor(c), out = [], perV = {};
        ((d && d.k === 'col' && d.ps) || []).forEach(function(p){
          if (!p.av || ic[p.id] || !okVendor(p, only)) return;
          var v = cheapestAvail(p); if (!v) return;
          var sim = simulate(c, v.p), ns = M.shipState({ total_price: sim.total, item_count: sim.units, currency: c.currency });
          if (!ns || ns.calculado || ns.freteAtual == null || !ns.atual) return;
          var nf = Math.round(ns.freteAtual * 100); if (nf >= cur) return;
          if (sim.total / 100 < ns.atual.de * 1.01) return;   /* folga de 1%: nao promete degrau no limite */
          out.push({ p: p, v: v, nf: nf, delta: (sim.total + nf) - (c.total_price + cur), tier: sim.tier > curTier ? sim.tier : 0 });
        });
        out.sort(function(a, b){ return a.delta - b.delta; });
        var pick = same.slice(0, 1);
        out.forEach(function(o){ var k = String(o.p.v || '').toLowerCase(); if (pick.length < 3 && (perV[k] || 0) < 2) { pick.push(o); perV[k] = (perV[k] || 0) + 1; } });
        if (!pick.length) { box.hidden = true; box.__ids = ''; return; }
        box.__ids = ',' + pick.map(function(o){ return o.p.id; }).join(',') + ',';
        box.innerHTML = '<div class="mkcd__bh"><h3>' + esc(tr('lad')) + '</h3></div>' + pick.map(function(o){
          var gain = o.nf === 0 ? tr('lfree') : tr('ldrop', { a: MF(cur), b: MF(o.nf) });
          if (o.tier) gain += ' ' + tr('ltier', { p: o.tier });
          var more = o.delta > 0 ? tr('lmore', { x: MF(o.delta) }) : (o.delta < 0 ? tr('lless', { x: MF(-o.delta) }) : '');
          var vt = o.v.t !== 'Default Title' ? ' · ' + o.v.t : '';
          var price = o.same ? ((o.unit < o.v.p ? '<s>' + MF(o.v.p) + '</s>' : '') + MF(o.unit)) : MF(o.v.p);
          return '<div class="mkcd__row' + (o.same ? ' is-same' : '') + '"><a class="mkcd__img" href="' + esc(o.p.u) + '" tabindex="-1">' + (o.p.img ? '<img src="' + esc(o.p.img) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>' +
            '<div class="mkcd__rt">' + (o.same ? '<span class="mkcd__tag">' + esc(tr('l1')) + '</span>' : '') + '<a class="mkcd__ttl" href="' + esc(o.p.u) + '">' + esc(o.p.t + vt) + '</a><div class="mkcd__cp">' + price + '</div>' +
            '<div class="mkcd__gain">' + esc(gain) + '</div>' + (more ? '<div class="mkcd__more">' + esc(more) + '</div>' : '') + '</div>' +
            '<button type="button" class="mkcd__add" data-mkcd-addv="' + o.v.i + '" data-src="' + (o.same ? 'ladder-same' : 'ladder') + '">' + esc(tr('add')) + '</button></div>';
        }).join('');
        box.hidden = false;
        M.pub('mkpbr_cdrw_ladder', { shown: pick.length, same: pick.length && pick[0].same ? 1 : 0 });
      });
    }

    /* =================== 3) COMPLETE SEU PEDIDO (recomendacao da Shopify) =================== */
    var upTok = 0;
    function upsell(c, root){
      var box = $('[data-mkcd-up]', root), tok = ++upTok;
      if (!c.item_count) { box.hidden = true; return; }
      var anchor = null; c.items.forEach(function(it){ if (!anchor || it.price > anchor.price) anchor = it; });
      recs(anchor.product_id).then(function(d){
        if (tok !== upTok) return;
        if (!d || d.k !== 'rec' || !d.ps) { box.hidden = true; return; }
        var ic = inCartIds(c), only = onlyVendor(c), skip = $('[data-mkcd-lad]', root).__ids || '';
        var ps = d.ps.filter(function(p){ return p.av && !ic[p.id] && okVendor(p, only) && skip.indexOf(',' + p.id + ',') < 0 && firstAvail(p); }).slice(0, 8);
        if (!ps.length) { box.hidden = true; return; }
        box.innerHTML = '<div class="mkcd__bh"><h3>' + esc(tr('up')) + '</h3><div class="mkcd__nav"><button type="button" data-dir="-1" aria-label="‹">‹</button><button type="button" data-dir="1" aria-label="›">›</button></div></div>' +
          '<div class="mkcd__sc">' + ps.map(function(p){
            var v = firstAvail(p), vt = v.t !== 'Default Title' ? ' · ' + v.t : '';
            return '<div class="mkcd__card"><a class="mkcd__img" href="' + esc(p.u) + '" tabindex="-1">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="60" height="60" loading="lazy">' : '') + '</a>' +
              '<div class="mkcd__rt"><a class="mkcd__ttl" href="' + esc(p.u) + '">' + esc(p.t + vt) + '</a><div class="mkcd__cp">' + (v.c > v.p ? '<s>' + MF(v.c) + '</s>' : '') + MF(v.p) + '</div></div>' +
              '<button type="button" class="mkcd__add" data-mkcd-addv="' + v.i + '" data-src="upsell">' + esc(tr('add')) + '</button></div>';
          }).join('') + '</div>';
        box.hidden = false;
        var sc = $('.mkcd__sc', box);
        [].forEach.call(box.querySelectorAll('[data-dir]'), function(b){
          b.addEventListener('click', function(){ var dir = Number(b.getAttribute('data-dir')) * (M.rtl ? -1 : 1); sc.scrollBy({ left: dir * sc.clientWidth * 0.8, behavior: 'smooth' }); });
        });
      });
    }
    /* "Pague menos frete" primeiro; o "Complete seu pedido" vem depois e pula o que ja apareceu la */
    M.hooks.render.push(function(c, root){
      var lad = ladder(c, root);
      (lad && lad.then ? lad : Promise.resolve()).then(function(){ upsell(c, root); }, function(){ upsell(c, root); });
    });
  }
  if (W.MKCD) boot(); else D.addEventListener('mkcd:ready', boot);
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else setTimeout(boot, 0);
})();